export default __webpack_public_path__ + "static/media/damnationofset.24297546.png";